import React from 'react';
import cn from 'classnames';
import Navbar from '~/components/navbar';
import {useQuery} from '@apollo/client';
import gql from 'graphql-tag';
import {filter} from 'graphql-anywhere';
import UnexpectedErrorScene from '~/scenes/system/UnexpectedErrorScene';
import UIContainer from '~/ui/UIContainer';
import {ToastNotificationListArea} from '~/components/ToastNotificationList';
import {createUseStyles} from 'react-jss';
import '../assets/toastify.css';
import ToastNotification from '../ui/ToastNotification';
import {AccountContext, UserContext} from '~/utils/Context';
import HelpScoutBeacon from "../components/utils/HelpScoutBeacon";
import Account from '../models/account/Account';

function AppLayout({children, className, fullScreen = false}) {
  const classes = useStyles();

  const {data, error} = useQuery(query);

  if (error) {
    return <UnexpectedErrorScene/>;
  }

  if (!data) {
    return null;
  }

  const accountQL = filter(Navbar.fragments.account, data.account);
  const account = new Account(accountQL);
  const user = data.me;

  return (
    <>
      {!!data && (
        <Navbar
          user={filter(Navbar.fragments.user, data.me)}
          account={accountQL}
        />
      )}
      <div className={cn(classes.contentArea, className)}>
        <ToastNotificationListArea
          className={classes.toastNotificationsArea}
        />
        <AccountContext.Provider value={account}>
          <UserContext.Provider value={user}>
            {fullScreen && children}
            {!fullScreen && (
              <UIContainer>
                {children}
              </UIContainer>
            )}
          </UserContext.Provider>
        </AccountContext.Provider>
        <ToastNotification/>
        <HelpScoutBeacon account={account} user={user}/>
      </div>
    </>
  );
}

const query = gql`
  query AppLayoutQuery {
    me {
      id
      email
      lastName
      ...NavbarUser
    }

    account {
      id
      __typename
      ...NavbarAccount
    }
  }

  ${Navbar.fragments.user}
  ${Navbar.fragments.account}
`;

const useStyles = createUseStyles({
  contentArea: {
    position: 'relative',
    minHeight: 'calc(100% - 50px)',
  },

  toastNotificationsArea: {
    position: 'absolute',
    right: 10,
    top: 8,
  },
});

export default AppLayout;
